import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { useAnalytics } from '@praxis/analytics/client'
import { useCallback } from 'react'
import styles from './heroBanner.module.scss'
import applyProps from '../../appConfig/applyConfig'

const HeroBanner = () => {
  const { sendClickEvent } = useAnalytics()

  const handlePartnerButtonClick = useCallback(() => {
    sendClickEvent('BECOME_PARTNER_FORM_BUTTON')
  }, [sendClickEvent])

  return (
    <Grid container flexDirection="row" className={styles.heroBannerContainer}>
      <Grid
        item
        alignItems="center"
        padding={{ xs: 4, md: 6, lg: 8 }}
        className={styles.heroContentContainer}
        sx={{ justifyContent: { xs: 'center', sm: 'normal' } }}
      >
        <Grid
          gap={{ xs: 2, md: 2, lg: 4 }}
          container
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          className={styles.heroContent}
        >
          <Grid item className={styles.heroHeading}>
            A curated
            <br /> marketplace
            <br />
            for <strong>growth</strong>
          </Grid>
          <Grid item className={styles.heroSubHeading}>
            Stand out to millions of Target guests <br />
            on an invite-only platform.
          </Grid>
          <Grid item>
            <Grid
              className={styles.heroBenefits}
              container
              flexDirection={{ xs: 'column', md: 'column', lg: 'row' }}
              gap={{ xs: 0, md: 1 }}
            >
              {[
                'Enhanced visibility',
                'Target-powered trust',
                'Scalable growth',
              ].map((value) => (
                <strong key={value}>{value}</strong>
              ))}
            </Grid>
          </Grid>
          <Grid item>
            <Button
              size="large"
              className="button-contained-ternary"
              {...applyProps}
              data-testid="become-partner-link"
              onClick={handlePartnerButtonClick}
              aria-label="Apply now"
            >
              Apply now
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HeroBanner
